import React from 'react'
import HeroTwo from '../components/heroTwo/HeroTwo';
import img from '../assets/contactus.jpg';
import SectionSix from '../components/section-six/SectionSix';
import './contact.css';
import Lottie from 'react-lottie';
import animationData from '../assets/contact.json';

function Contact() {

    const defaultOptions = {
        loop: true,
        autoplay: true,
        animationData: animationData,
        rendererSettings: {
          preserveAspectRatio: "xMidYMid slice"
        }
      }; 

    return (
        <div className='contact__main'>
              <HeroTwo 
            head='Contact Us'
            image={img}
            />
            <div className="contact__form">
                <div className="contact__left">
                <Lottie 
                    options={defaultOptions}
                    height={400}
                    width={400}
                />
                </div>
                <div className="contact__right">
                  <SectionSix />
                </div>
            
            </div>
        </div>
    )
}

export default Contact
